/**
 * DE TAALSCHAKELAAR, NL/EN-batch opdracht A1 (15 oktober 2026).
 *
 * Eén woordenlijst per taal en één functie die eruit leest. Nederlands is de
 * standaard, want zo stond de app tot vandaag. Een sleutel die in het Engels
 * ontbreekt valt terug op het Nederlands en niet op de sleutel zelf: een
 * halve vertaling is beter leesbaar dan `sidebar.nieuweChat` op het scherm.
 *
 * HET WELKOMSTSCHERM STAAT HIER MET OPZET NIET IN. "How can I help you evolve
 * today?" blijft altijd Engels (besluit Frank), en een sleutel zou uitnodigen
 * om hem toch te vertalen.
 *
 * De keuze staat op twee plekken: hier in de browser, zodat het eerste beeld
 * meteen klopt, en in `user_settings.taal`, zodat de Mac en de PWA hem delen en
 * de backend er antwoordtaal en geheugen op afstemt.
 */

import { EN_VAN_NL } from "./taal-en";

export const NL = "nl";
export const EN = "en";
export const TALEN = [NL, EN];
const SLEUTEL = "novamund_taal";

export const TEKSTEN = {
  [NL]: {
    "taal.kies": "Taal",
    "taal.nl": "Nederlands",
    "taal.en": "English",
    "taal.uitleg": "Geldt voor menu, knoppen, kaarten, meldingen en de taal van de antwoorden.",

    "menu.nieuweChat": "Nieuwe chat",
    "menu.menu": "Menu",
    "menu.chats": "Chats",
    "menu.projecten": "Projecten",
    "menu.artefacten": "Artefacten",
    "menu.teams": "Teams",
    "menu.abonnement": "Abonnement",
    "menu.netwerk": "Netwerk",
    "menu.winkel": "Winkel",
    // Glasronde 0.9.189 vondst 6 (Frank 22 oktober 2026): in het Nederlands stond hier Knowledge.
    "menu.knowledge": "Kennis",
    "menu.koppelingen": "Koppelingen",
    "menu.skills": "Skills",
    "menu.agenten": "Agenten",
    "menu.code": "Code",
    "menu.chat": "Chat",
    "menu.geheugen": "Geheugen",
    "menu.geheugenVoorgesteld": "Geheugen, {n} voorgesteld",
    "menu.postbus": "Postbus",
    "menu.postbusWachtend": "Postbus, {n} wachtend",
    "menu.nieuwProject": "Nieuw project",
    "menu.projectenFilteren": "Projecten filteren",
    "menu.projectOpenen": "Project openen",
    "menu.nogGeenArtefacten": "Nog geen artefacten",
    "menu.projectchats": "Projectchats",
    "menu.recent": "Recent",
    "menu.naarProject": "Naar project",
    "menu.upgrade": "Upgrade naar Pro",
    "menu.licht": "Licht",
    "menu.donker": "Donker",
    "menu.instellingen": "Instellingen",
    "menu.lokaleGebruiker": "Lokale gebruiker",
    "menu.afmelden": "Afmelden",
    "menu.aanmelden": "Aanmelden",
    "menu.chatHernoemen": "Chat hernoemen",
    "menu.nieuweTitel": "Nieuwe titel",
    "menu.annuleren": "Annuleren",
    "menu.opslaan": "Opslaan",
    "menu.projectAanmaken": "Project aanmaken",
    "menu.projectnaam": "Projectnaam",
    "menu.aanmaken": "Aanmaken",
    "menu.chatVerwijderen": "Deze chat verwijderen?",
    "menu.dezeChat": "Deze chat",
    "menu.hernoemen": "Hernoemen",
    "menu.uitProject": "Uit project halen",
    "menu.exportMarkdown": "Exporteren als Markdown",
    "menu.exportJson": "Exporteren als JSON",
    "menu.exportWord": "Exporteren als Word",
    "menu.exportPdf": "Exporteren als PDF",
    "menu.chatVerwijderenKnop": "Chat verwijderen",
    "menu.verwijderUitleg": "en al zijn berichten worden verwijderd, samen met het spoor van hoe elk antwoord tot stand kwam. Dit kan niet ongedaan worden gemaakt.",

    "kop.verversen": "Verversen",
    "kop.tijdmachine": "Time machine: kijk terug wat er wanneer is gezegd",
    "kop.universum": "Universum: alle verbindingen als grafiek",
    "kop.opdrachten": "Typ / voor opdrachten, @ voor een agent",
    "kop.stop": "Stop het antwoord",
  },
  [EN]: {
    "taal.kies": "Language",
    "taal.nl": "Nederlands",
    "taal.en": "English",
    "taal.uitleg": "Applies to the menu, buttons, cards, notices and the language of the answers.",

    "menu.nieuweChat": "New chat",
    "menu.menu": "Menu",
    "menu.chats": "Chats",
    "menu.projecten": "Projects",
    "menu.artefacten": "Artifacts",
    "menu.teams": "Teams",
    "menu.abonnement": "Billing",
    "menu.netwerk": "Network",
    "menu.winkel": "Store",
    "menu.knowledge": "Knowledge",
    "menu.koppelingen": "Connections",
    "menu.skills": "Skills",
    "menu.agenten": "Agents",
    "menu.code": "Code",
    "menu.chat": "Chat",
    "menu.geheugen": "Memory",
    "menu.geheugenVoorgesteld": "Memory, {n} suggested",
    "menu.postbus": "Inbox",
    "menu.postbusWachtend": "Inbox, {n} waiting",
    "menu.nieuwProject": "New project",
    "menu.projectenFilteren": "Filter projects",
    "menu.projectOpenen": "Open project",
    "menu.nogGeenArtefacten": "No artifacts yet",
    "menu.projectchats": "Project chats",
    "menu.recent": "Recent",
    "menu.naarProject": "Move to project",
    "menu.upgrade": "Upgrade to Pro",
    "menu.licht": "Light",
    "menu.donker": "Dark",
    "menu.instellingen": "Settings",
    "menu.lokaleGebruiker": "Local user",
    "menu.afmelden": "Sign out",
    "menu.aanmelden": "Sign in",
    "menu.chatHernoemen": "Rename chat",
    "menu.nieuweTitel": "New title",
    "menu.annuleren": "Cancel",
    "menu.opslaan": "Save",
    "menu.projectAanmaken": "Create project",
    "menu.projectnaam": "Project name",
    "menu.aanmaken": "Create",
    "menu.chatVerwijderen": "Delete this chat?",
    "menu.dezeChat": "This chat",
    "menu.hernoemen": "Rename",
    "menu.uitProject": "Remove from project",
    "menu.exportMarkdown": "Export as Markdown",
    "menu.exportJson": "Export as JSON",
    "menu.exportWord": "Export as Word",
    "menu.exportPdf": "Export as PDF",
    "menu.chatVerwijderenKnop": "Delete chat",
    "menu.verwijderUitleg": "and all its messages will be deleted, together with the trail of how each answer came about. This cannot be undone.",

    "kop.verversen": "Refresh",
    "kop.tijdmachine": "Time machine: look back at what was said when",
    "kop.universum": "Universe: every connection as a graph",
    "kop.opdrachten": "Type / for commands, @ for an agent",
    "kop.stop": "Stop the answer",
  },
};

/**
 * A2 (15 oktober 2026): voor de overige schermen is de NEDERLANDSE TEKST ZELF de
 * sleutel, `t("Instellingen")`. Op NL komt hij ongewijzigd terug; op EN uit
 * `EN_VAN_NL`. Zo blijft de bron leesbaar en staat de vertaling op een plek.
 * Een wachter (`taal-dekking.test.js`) eist dat elke `t("...")` er een heeft.
 */
export { EN_VAN_NL };

/** Een bekende taal, anders Nederlands. PUUR. */
export function geldigeTaal(taal) {
  return TALEN.includes(taal) ? taal : NL;
}

/**
 * De tekst bij een sleutel. Ontbreekt hij in de gekozen taal, dan het
 * Nederlands; ontbreekt hij ook daar, dan de sleutel, zodat een tikfout
 * zichtbaar is in plaats van een leeg vak. `{n}` wordt ingevuld. PUUR.
 */
export function vertaal(taal, sleutel, waarden) {
  const t = geldigeTaal(taal);
  const tekst = TEKSTEN[t][sleutel] ?? (t === EN ? EN_VAN_NL[sleutel] : undefined) ?? TEKSTEN[NL][sleutel] ?? sleutel;
  if (!waarden) return tekst;
  return tekst.replace(/\{(\w+)\}/g, (heel, naam) => (naam in waarden ? String(waarden[naam]) : heel));
}

export function bewaardeTaal() {
  try {
    return geldigeTaal(localStorage.getItem(SLEUTEL));
  } catch {
    return NL;
  }
}

export function bewaarTaal(taal) {
  try {
    localStorage.setItem(SLEUTEL, geldigeTaal(taal));
  } catch {
    // Privévenster of geblokkeerde opslag: de keuze geldt dan deze sessie.
  }
}
